import { YStack, XStack, Text, styled } from 'tamagui'
import { Card } from '../ui'
import { copy } from '../../content/copy'

const Section = styled(YStack, {
  name: 'ProblemAgitateSection',
  paddingHorizontal: '$6',
  paddingVertical: '$16',
  backgroundColor: '$background',

  '$md': {
    paddingHorizontal: '$4',
    paddingVertical: '$10',
  },
})

const Container = styled(YStack, {
  name: 'Container',
  maxWidth: 1200,
  marginHorizontal: 'auto',
  width: '100%',
  gap: '$10',
})

const Header = styled(XStack, {
  name: 'Header',
  alignItems: 'flex-start',
  gap: '$4',
  marginBottom: '$4',
})

const SectionNumber = styled(Text, {
  name: 'SectionNumber',
  fontFamily: '$accent',
  fontSize: '$2',
  color: '$textMuted',
  letterSpacing: 2,
})

const SectionTitle = styled(Text, {
  name: 'SectionTitle',
  // @ts-ignore - Tamagui's `render` controls the underlying HTML element on web
  render: 'h2',
  fontFamily: '$accent',
  fontSize: '$3',
  color: '$orangePrimary',
  letterSpacing: 2,
  textTransform: 'uppercase',
})

const ProblemsGrid = styled(YStack, {
  name: 'ProblemsGrid',
  gap: '$6',

  '$gtMd': {
    flexDirection: 'row',
    gap: '$6',
  },
})

const ProblemCard = styled(Card, {
  name: 'ProblemCard',
  gap: '$4',

  '$gtMd': {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 0,
  },

  '$md': {
    padding: '$5',
  },
})

const ProblemTitle = styled(Text, {
  name: 'ProblemTitle',
  // @ts-ignore - Tamagui's `render` controls the underlying HTML element on web
  render: 'h3',
  fontFamily: '$heading',
  fontSize: '$6',
  fontWeight: '600',
  color: '$textPrimary',
  lineHeight: '$6',

  '$gtMd': {
    minHeight: 56,
  },

  '$md': {
    fontSize: '$5',
  },
})

const ProblemDescription = styled(Text, {
  name: 'ProblemDescription',
  fontFamily: '$body',
  fontSize: '$4',
  lineHeight: '$5',
  color: '$textSecondary',
})

const AgitationText = styled(Text, {
  name: 'AgitationText',
  fontFamily: '$body',
  fontSize: '$4',
  fontStyle: 'italic',
  color: '$orangePrimary',
  borderLeftWidth: 2,
  borderLeftColor: '$orangePrimary',
  paddingLeft: '$4',
  marginTop: '$2',
})

export function ProblemAgitateSection() {
  const { sectionNumber, sectionTitle, problems } = copy.problemAgitate

  return (
    <Section>
      <Container>
        <Header>
          <SectionNumber>{sectionNumber}</SectionNumber>
          <SectionTitle>{sectionTitle}</SectionTitle>
        </Header>

        <ProblemsGrid>
          {problems.map((problem, index) => (
            <ProblemCard key={index} variant="elevated">
              <ProblemTitle>{problem.title}</ProblemTitle>
              <ProblemDescription>{problem.description}</ProblemDescription>
              <AgitationText>"{problem.agitation}"</AgitationText>
            </ProblemCard>
          ))}
        </ProblemsGrid>
      </Container>
    </Section>
  )
}
